import {Component} from 'react';


class Config extends Component {

   

}

export default Config;